import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.scss';
import TopMenu from '../top-menu/TopMenu';
import { useLocation } from 'react-router-dom';
import Search from '../search/Search';
import { IData } from '../../interfaces/IData';
import Sidebar from '../sidebar/Sidebar';

type NavigationProps = {
  content: IData | undefined;
  search: (data: string) => void;
};

function Navigation({ search, content }: NavigationProps) {
  const isHome = useLocation().pathname === '/';

  if (!content) {
    return null;
  }

  return (
    <nav className="navigation">
      <div className="nav-inner">
        <Sidebar />

        <Link className="brand" to={{pathname: `/`}}>
          <div
            className="brand-logo"
            style={{ backgroundImage: 'url("' + (content['logo'] || '/favicon.png') + '")' }}
          />
          <div className="brand-meta">
            <div className="brand-title">{content['channel_title'] || 'syntaxyts'}</div>
            <div className="brand-subs">
              <span className="live-dot"/>{content['subscribers']}
            </div>
          </div>
        </Link>

        <div className="desktop-search">
          {isHome && <Search setKeyword={search} />}
        </div>

        <TopMenu />
      </div>
    </nav>
  );
}

export default Navigation;
